(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#acheter"]');
    if (!a) return;
    e.preventDefault();
    var target = document.querySelector('.product-info') || document.querySelector('#offre-timer') || document.querySelector('[id$="__main"]');
    if (!target) return;
    var header = document.querySelector('header');
    var sticky = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - sticky - 12;
    window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
  });
})();
